module.exports = "/assets/7710555fbe343ee6f882c6f5f6b496c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OK.png
// module id = 1683
// module chunks = 0